import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUser, FaLock } from "react-icons/fa";
import { AdminAPI } from "../api/api";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await AdminAPI.login(email, password); // la cookie JWT se establece automáticamente

      // ✅ Esperar que el backend valide la sesión
      await new Promise(resolve => setTimeout(resolve, 300)); // 300ms de espera
      await AdminAPI.me(); // opcional: asegurarse de que la cookie ya está activa

      window.location.href = "/admin"; // redirige y recarga
    } catch (err) {
      console.error("Error login:", err);
      setError(err.message || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <div className="card shadow-lg p-4" style={{ width: "360px", borderRadius: "12px" }}>
        <div className="text-center mb-4">
          <img
            src="/assets/Logo.png"
            alt="Inerva Psicología"
            style={{ height: "auto", minHeight: "200px", maxHeight: "260px", objectFit: "contain" }}
          />
          <h3 className="fw-bold text-success">Acceso Administrador</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">
              <FaUser className="me-2" /> Correo electrónico
            </label>
            <input
              type="email"
              className="form-control"
              placeholder="ejemplo@correo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">
              <FaLock className="me-2" /> Contraseña
            </label>
            <input
              type="password"
              className="form-control"
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="alert alert-danger py-2">{error}</div>}

          <button type="submit" className="btn btn-success w-100 py-2 fw-bold" disabled={loading}>
            {loading ? "Iniciando..." : "Iniciar sesión"}
          </button>
        </form>
      </div>
    </div>
  );
}
